import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only intercept requests to Google APIs
    if (request.url.includes('googleapis.com')) {
      return this.authService.getGoogleAccessToken().pipe(
        first(), // Take the first emitted value and complete
        switchMap(tokenResponse => {
          if (tokenResponse && tokenResponse.accessToken) {
            // Clone the request and add the authorization header
            const clonedReq = request.clone({
              headers: request.headers.set('Authorization', `Bearer ${tokenResponse.accessToken}`)
            });
            return next.handle(clonedReq);
          } else {
            // If no token, proceed with the original request.
            // This will likely fail, which is the expected behavior.
            return next.handle(request);
          }
        })
      );
    }

    // For all other requests, pass them through without modification
    return next.handle(request);
  }
}
